import { translate } from '@openclassrooms/translations';

const getLearningContentWording = () => ({
  duration: translate('learning_content.duration.label'),
  releaseDateOpening: translate('learning_content.release_date_opening'),
  durationMonths: (count: number) =>
    translate('learning_content.duration.months', { count }, count),
  durationHours: (count: number) => translate('learning_content.duration.hours', { count }, count),
  durationMinutes: (count: number) =>
    translate('learning_content.duration.minutes', { count }, count),
  releaseSpring: (year: number) => translate('learning_content.release_season.spring', { year }),
  releaseSummer: (year: number) => translate('learning_content.release_season.summer', { year }),
  releaseFall: (year: number) => translate('learning_content.release_season.fall', { year }),
  releaseWinter: (year: number) => translate('learning_content.release_season.winter', { year }),
  durationFullTimeMonths: (count: number) =>
    translate(
      'path_details.path_card.meta.full_time.months',
      { path_duration_months: count },
      count
    ),
  durationFullTimeHours: (count: number) =>
    translate('path_details.path_card.meta.full_time.hours', { path_duration_hours: count }, count),
  durationApprenticeshipMonths: (count: number) =>
    translate(
      'path_details.path_card.meta.apprenticeship.months',
      { apprenticeship_duration_months: count },
      count
    ),
  durationApprenticeshipHours: (count: number) =>
    translate(
      'path_details.path_card.meta.apprenticeship.hours',
      { apprenticeship_duration_hours: count },
      count
    ),
  trainingPeriodFullTimeMonths: (count: number) =>
    translate('path_details.training_period.meta', { training_period_months: count }, count),

  trainingPeriodFullTimeHours: (count: number) =>
    translate('path_details.training_duration.meta', { training_duration_hours: count }, count),
  apprenticeshipDurationMonths: (count: number) =>
    translate('learning_content.apprenticeship_duration.months', { duration_months: count }, count),
});

export default getLearningContentWording;
